// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { BundleResponse, bundleResponseSchema } from '@/bundle/api/types';

/**
 * Parameters for updating a bundle.
 * All fields are optional; only provided fields will be updated.
 */
export interface UpdateBundleParameters {
  name?: string;
  description?: string | null;
  isArchived?: boolean;
}

/**
 * Updates a bundle's details.
 * Returns the updated bundle including its members.
 */
export async function updateBundle(
  key: string,
  parameters: UpdateBundleParameters
): Promise<BundleResponse> {
  const url = `/v1/catalog/bundle/${key}`;
  const response = await api.patch(url, parameters);
  return parseResponse(bundleResponseSchema, response.data, {
    schemaName: 'UpdateBundle',
    endpoint: url,
  });
}
